<template>
    <transition name="slide-fade">
        <div class="modal" :class="{'open' : open}" v-if="open" data-cy="modal_otp">
            <div class="modal-content" data-cy="container_modal_content">
                <div class="bg-white w-full rounded-xl p-3" data-cy="container_modal_body">
                    <div class="text-center" data-cy="container_otp_header">
                        <div class="text-lg font-bold mb-3" data-cy="text_otp_title">กรุณากรอกรหัส OTP</div>
                        <div data-cy="text_otp_description">รหัส OTP จะถูกส่ง SMS</div>
                        <div data-cy="text_otp_phone">ไปที่เบอร์โทรศัพท์มือถือ {{FilterPhoneFormat(tel)}}</div>
                        <div data-cy="text_otp_refcode">รหัสอ้างอิง : {{refcode}}</div>
                    </div>
                    <div class="relative mt-5 px-3" data-cy="container_otp_input">
                        <label for="input-otp" data-cy="label_otp_input">
                            <div class="grid grid-cols-6 gap-2 text-center" data-cy="container_otp_digits">
                                <div class="border py-1 h-9" data-cy="input_otp_digit_0">{{inputOtp[0]}}</div>
                                <div class="border py-1 h-9" data-cy="input_otp_digit_1">{{inputOtp[1]}}</div>
                                <div class="border py-1 h-9" data-cy="input_otp_digit_2">{{inputOtp[2]}}</div>
                                <div class="border py-1 h-9" data-cy="input_otp_digit_3">{{inputOtp[3]}}</div>
                                <div class="border py-1 h-9" data-cy="input_otp_digit_4">{{inputOtp[4]}}</div>
                                <div class="border py-1 h-9" data-cy="input_otp_digit_5">{{inputOtp[5]}}</div>
                            </div>
                        </label>
                        <input type="tel" id="input-otp" maxlength="6" v-model="inputOtp" data-cy="input_otp_hidden" @input="onOtpChange()">
                    </div>
                    <div class="text-center mt-4" v-if="!isExpireTime" data-cy="text_otp_timer">
                        รหัสจะหมดอายุภายใน <span data-cy="text_otp_countdown">{{displayTime}}</span> วินาที
                    </div>
                    <div v-else class="text-center font-bold text-green-600 underline" data-cy="btn_otp_resend" @click="clickResendOtp()">
                        Resend OTP
                    </div>
                    <div v-show="errorMsg != ''" class="text-center text-red-500" data-cy="label_error_otp">
                        {{errorMsg}}
                    </div>
                    <div class="mt-4" data-cy="container_otp_actions">
                        <BlueButton data-cy="btn_otp_confirm_active" @click="clickSubmitOtp()">Confirm</BlueButton>
                    </div>
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open" data-cy="container_modal_backdrop"></div>
    </transition>
</template>
<script>
// import Util from '@/helper/Utility.js';
import RegxHelper from '@/helper/RegxHelper';
import TimerHelper from '@/helper/TimerHelper.js';
//mixin
import LocaleMixin from '@/mixin/LocaleMixin.js';
//component
import BlueButton from '@/components/Button/BlueButton.vue';
//service
import BzbsOtp from '@/core/Account/service/BzbsOtp.js';
import { OtpModel } from '@/core/Account/model/OtpModel';

export default {
    name: "OtpModal",
    mixins: [LocaleMixin],
    components: {
        BlueButton,
    },
    props: {
        controller: Object,
    },
    data: function() {
        return {
            open: false,
            busModal: null,
            isEnableRequest: false,

            inputOtp: '',
            otpLifeTime: 1, // minute
            timer: new TimerHelper(),
            displayTime: '',
            isExpireTime: false,
            errorMsg: '',

            tel: '',
            refcode: '',
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
        this.timer.initialTimer(this.otpLifeTime * 60, ':', false, false);
    },
    mounted: function() {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
        this.busModal.on('startOtp', this.startOtp);
        this.busModal.on('setErrorMsg', this.setErrorMsg);
        this.busModal.on('clearInputOtp', this.clearInputOtp);
        this.busModal.on('closeOtp', this.closeOtp);
    },
    watch: {
        '$route.path': function() {
            if (this.open) {
                this.closeOtp();
            }
        },
    },
    methods: {
        show: function() {
            document.body.classList.add('not-scroll');
            this.open = true;
        },
        hide: function() {
            document.body.classList.remove('not-scroll');
            this.open = false;
        },
        startOtp: function(config) {
            console.log(config);
            this.tel = config.tel;
            this.isEnableRequest = config.enableRequest;
            this.timer.stopTimer();
            this.timer.resetTimer();
            this.clearInputOtp();

            if (config.enableRequest) {
                this.apiRequestOtp().then((refcode) => {
                    this.refcode = refcode;
                    this.startTimeOtp();
                });
            } else {
                this.refcode = config.refcode;
                this.startTimeOtp();
            }

            this.show();
        },
        closeOtp: function() {
            this.timer.stopTimer();
            this.timer.resetTimer();
            this.clearInputOtp();
            this.setErrorMsg('');
            this.hide();
        },
        setErrorMsg: function(msg) {
            this.errorMsg = msg;
        },
        clearInputOtp: function() {
            this.inputOtp = '';
        },
        clickOk: function () {
            this.hide();
            this.controller.sendCallbackOk();
        },

        onOtpChange: function() {
            this.inputOtp = RegxHelper.removeNotNumber(this.inputOtp);
        },
        clickResendOtp: function() {
            this.timer.stopTimer();
            this.timer.resetTimer();

            if (this.isEnableRequest) {
                // call request otp
                this.apiRequestOtp().then((refcode) => {
                    this.refcode = refcode;
                    this.startTimeOtp();
                });
            } else {
                this.hide();
                this.controller.sendCallbackResendOtp()
            }
        },
        clickSubmitOtp: function() {
            if (!this.isExpireTime && this.inputOtp.length == 6) {
                let otpModel = new OtpModel()
                        .setContactNumber(this.tel)
                        .setRefcode(this.refcode)
                        .setOtp(this.inputOtp);
                this.controller.sendCallbackSubmitOtp(otpModel);
                this.hide();
            }
        },

        //#region time otp
        startTimeOtp: function() {
            this.isExpireTime = false;
            this.timer.runTimer((displayTime) => {
                this.displayTime = displayTime;
            }, () => {
                this.onOtpTimeExpire();
            })
        },
        onOtpTimeExpire: function() {
            this.timer.stopTimer();
            this.timer.resetTimer();
            this.isExpireTime = true;
        },
        //#endregion time otp

        //#region request otp
        apiRequestOtp: function() {
            return new Promise((resolve) => {
                BzbsOtp.requestOtp(this.tel, 'contact_number', null).subscribe({
                    next: (data) => {
                        console.log(data);
                        resolve(data.data.refcode);
                    },
                    error: (err) => {
                        console.log(err);
                        this.onErrorApi(err);
                    },
                })
            });
        },
        onErrorApi: function(err) {
            this.hide(err);
            this.controller.sendCallbackErrorApi(err);
        },
        //#endregion request otp
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/modal.scss";
    .modal {
        @extend %modal;

        .modal-content {
            width: 100%;
            max-width: 350px;
            padding: 16px;
        }
    }

    #input-otp {
        opacity: 0;
        position: absolute;
        top: -20000px;
        left: -20000px;
    }
</style>
